/* eslint-disable no-undef */
import dayjs from 'dayjs';
import { Base64 } from 'js-base64';
import { NetworkContext } from '../types/network';
import isJSON from '../utils/isJSON';

export const getItem = async (key: string, _?: NetworkContext) => {
  let value = null;

  const parts = document.cookie.split('; ').find((row) => row.startsWith(`${key}=`));

  if (parts) {
    value = parts.replace(`${key}=`, '');
  }

  if (typeof value === 'string' && key.includes('_unsafe')) {
    value = Base64.decode(value);
  }

  if (typeof value === 'string') {
    return isJSON(value) ? JSON.parse(value) : value;
  }

  return value;
};

export const setItem = async (key: string, value: any, _?: NetworkContext) => {
  const expires = dayjs().add(90, 'days').toDate();
  let jValue = JSON.stringify(value);

  if (key.includes('_unsafe')) {
    jValue = Base64.encode(jValue);
  }

  document.cookie = `${key}=${jValue}; expires=${expires.toUTCString()}; SameSite=Strict; path=/`;

  return null;
};

export const removeItem = async (key: string, _?: NetworkContext) => {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Strict; path=/`;

  return null;
};
